import BrandsHeader from './img/Services/Shop_full.png'

export default {
  BrandsHeader
}


// WEBPACK FOOTER //
// ./src/backgrounds.js